import React, { Component } from 'react';
import ReactConfirmAlert from './ConfirmAlert';

import './notificationPopup.scss';

import { observer, inject } from 'mobx-react';

@inject('settingsStore')
@observer
class NotificationPopup extends Component {
  constructor(props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  close(callback) {
    callback = callback || this.props.onCancel;
    callback && callback();
    this.props.settingsStore.notificationState = { show: false };
  }

  handleKeyDown(e) {
    if (e.keyCode === 27) {
      this.close();
    }

    return false;
  }

  componentDidUpdate() {
    if (this.props.settingsStore.notificationState.show) {
      document.addEventListener('keypress', this.handleKeyDown);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this.handleKeyDown);
  }

  render() {
    const notificationState = this.props.settingsStore.notificationState;
    return (
      notificationState.show && (
        <div>
          <ReactConfirmAlert
            title={notificationState.title || ''}
            message={notificationState.message || ''}
            confirmLabel={notificationState.confirmLabel || 'OK'}
            cancelLabel={notificationState.cancelLabel || null}
            onConfirm={this.close.bind(this, notificationState.onConfirm)}
            onCancel={this.close.bind(this, notificationState.onCancel)}
            closeOnEsc={true}
            childrenElement={
              notificationState.ChildElement &&
              (() => (
                <div className="content-wrapper">
                  <notificationState.ChildElement />
                </div>
              ))
            }
          />
        </div>
      )
    );
  }
}

export default NotificationPopup;



// WEBPACK FOOTER //
// ./src/common/core/notifications/NotificationPopup.jsx